{
"catalog": {
" company has been added": " unternehmen wurde hinzugef\u00fcgt",
" day. Renew now to continue enjoying uninterrupted access.": " Tag. Jetzt verl\u00e4ngern, um weiterhin ununterbrochenen Zugang zu genie\u00dfen.",
" days. Renew now to continue enjoying uninterrupted access.": " Tage. Jetzt verl\u00e4ngern, um weiterhin ununterbrochenen Zugriff zu genie\u00dfen.",
"(\u00d8re/kWh)": "(\u00d8re/kWh)",
"0.00": "0,00",
": The new company has been added": ": Das neue Unternehmen wurde hinzugef\u00fcgt",
"A code of reference ( Who referred a company)": "Ein Referenzkodex ( Wer hat ein Unternehmen empfohlen)",
"A link has been sent to your email address to reset password": "Ein Link zum Zur\u00fccksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet",
"A link has been sent to your email address to reset password.": "Ein Link zum Zur\u00fccksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet.",
"A newer version of this application is available. The update will begin automatically in 20 seconds.": "Eine neuere Version dieser Anwendung ist verf\u00fcgbar. Die Aktualisierung beginnt automatisch in 20 Sekunden.",
"A suspicious activity was detected. For security reasons, you must log in again": "Es wurde eine verd\u00e4chtige Aktivit\u00e4t festgestellt. Aus Sicherheitsgr\u00fcnden m\u00fcssen Sie sich erneut anmelden",
"API Documentation": "API-Dokumentation",
"API Key": "API-Schl\u00fcssel",
"API key": "API-Schl\u00fcssel",
"Access from partner website": "Zugang von der Partner-Website",
"Access given": "Zugang gew\u00e4hrt",
"Access is Required!": "Zugang ist erforderlich!",
"Access period": "Zugangsfrist",
"Account Setup": "Konto-Setup",
"Account creation code": "Code f\u00fcr die Kontoer\u00f6ffnung",
"Actions": "Aktionen",
"Active": "Aktiv",
"Active Users": "Aktive Benutzer",
"Active Users List": "Liste aktiver Benutzer",
"Add": "Hinzuf\u00fcgen",
"Add Contract": "Vertrag hinzuf\u00fcgen",
"Add Corporate Group": "Unternehmensgruppe hinzuf\u00fcgen",
"Add Customer": "Kunden hinzuf\u00fcgen",
"Add Document": "Dokument hinzuf\u00fcgen",
"Add New Corporate Group": "Neue Unternehmensgruppe hinzuf\u00fcgen",
"Add New Feature": "Neue Funktion hinzuf\u00fcgen",
"Add New Module": "Neues Modul hinzuf\u00fcgen",
"Add New Partner": "Neuen Partner hinzuf\u00fcgen",
"Add New Subscription": "Neues Abonnement hinzuf\u00fcgen",
"Add New User": "Neuen Benutzer hinzuf\u00fcgen",
"Add Partner": "Partner hinzuf\u00fcgen",
"Add User": "Benutzer hinzuf\u00fcgen",
"Add a new role": "Eine neue Rolle hinzuf\u00fcgen",
"Add company": "Unternehmen hinzuf\u00fcgen",
"Add contract": "Vertrag hinzuf\u00fcgen",
"Add feature": "Feature hinzuf\u00fcgen",
"Add permission": "Berechtigung hinzuf\u00fcgen",
"Add role": "Rolle hinzuf\u00fcgen",
"Add subscription plan": "Abonnementplan hinzuf\u00fcgen",
"Address": "Adresse",
"Aggregated": "Aggregierte",
"Aggregation": "Aggregation",
"Alias": "Alias",
"All": "Alle",
"All Documents": "Alle Dokumente",
"All Users": "Alle Benutzer",
"All kWh": "Alle kWh",
"All notifications deleted successfully": "Alle Benachrichtigungen wurden erfolgreich gel\u00f6scht.",
"All notifications marked as read": "Alle Benachrichtigungen als \"Gelesen\" markiert",
"Alpha numeric and dash only": "Nur alphanumerische Zeichen und Bindestriche",
"Already have an account?": "Du hast bereits ein Konto?",
"Amount of money for consumption": "Geldbetrag f\u00fcr Konsum",
"An error occurred while deleting the document": "Beim L\u00f6schen des Dokuments ist ein Fehler aufgetreten.",
"An error occurred while the system was generating the report. Please try again. You can contact support If this continues.": "Bei der Erstellung des Berichts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Sie k\u00f6nnen sich an den Support wenden, wenn das Problem weiterhin besteht.",
"An unexpected error occurred. It has been logged, and we are working on a resolution.": "Es ist ein unerwarteter Fehler aufgetreten. Er wurde protokolliert, und wir arbeiten an einer L\u00f6sung.",
"Annual CO\u2082e (Kg)": "J\u00e4hrliche CO\u2082e (kg)",
"Annual Statement": "J\u00e4hrliche Erkl\u00e4rung",
"Annual energy consumption (kWh)": "J\u00e4hrlicher Energieverbrauch (kWh)",
"App": "App",
"App URL": "App URL",
"Apr": "Apr",
"Apr: Checking": "Apr: \u00dcberpr\u00fcfung von",
"Apr: Get": "Apr: Abrufen",
"Apr: Update": "Apr: Aktualisierung",
"April": "April",
"Are you sure you want to delete?": "Wollen Sie dies wirklich l\u00f6schen?",
"Attach Company with User": "Firma mit Benutzer anh\u00e4ngen",
"Aug": "Aug",
"Aug: Checking": "Aug: \u00dcberpr\u00fcfung von",
"Aug: Get": "Aug: Abrufen",
"Aug: Update": "Aug: Update",
"August": "August",
"Authority Processing": "Beh\u00f6rde Verarbeitung",
"Authorization": "Autorisierung",
"Availability Payment": "Verf\u00fcgbarkeit Zahlung",
"Availability Rate": "Verf\u00fcgbarkeitsrate",
"Back": "Zur\u00fcck",
"Back to": "Zur\u00fcck zur",
"Back to Documents": "zur\u00fcck zu den Dokumenten",
"Before getting started, could you verify your email address by ": "Bevor Sie beginnen, k\u00f6nnten Sie Ihre E-Mail-Adresse verifizieren, indem Sie ",
"Blocked": "Gesperrt",
"Building": "Geb\u00e4ude",
"Building address": "Adresse des Geb\u00e4udes",
"Building is required": "Geb\u00e4ude ist erforderlich",
"But you still need to know more.": "Aber Sie m\u00fcssen noch mehr wissen.",
"CAPTCHA verification failed. Please try again.": "CAPTCHA-\u00dcberpr\u00fcfung fehlgeschlagen. Bitte versuchen Sie es erneut.",
"CCPA Privacy Rights (Do Not Sell My Personal Information)": "CCPA-Datenschutzrechte (Verkaufen Sie meine pers\u00f6nlichen Daten nicht)",
"CO\u2082_per_m2": "CO\u2082_pro_m2",
"CO\u2082e": "CO\u2082e",
"CO\u2082e (Kg)": "CO\u2082e (kg)",
"CVR": "Handelsregisternummer",
"Cached": "Zwischengespeichert",
"Cancel": "Abbrechen",
"Carbon Emissions (Kg CO\u2082e)": "Kohlenstoffemissionen (kg CO\u2082e)",
"Carbon Footprint (g CO\u2082e/kWh)": "Kohlenstoff-Fu\u00dfabdruck (g CO\u2082e/kWh)",
"Carbon dioxide Consumption": "Kohlendioxid Verbrauch",
"Cashed Statement - Under Development": "Cashed Statement - In Entwicklung",
"Central business Register number": "Nummer des zentralen Unternehmensregisters",
"Change Password": "Passwort \u00e4ndern",
"Change password": "Passwort \u00e4ndern",
"Child Company": "Tochtergesellschaft",
"Child company and above level access": "Tochtergesellschaft und Zugang auf h\u00f6herer Ebene",
"City": "Ort",
"Click to copy": "Klicken zum kopieren",
"Click to upload or drag and drop": "Zum Hochladen anklicken oder per Drag & Drop verschieben",
"Climate": "Klima",
"Climate report": "Klimabericht",
"Close": "Schlie\u00dfen",
"Co2 Certificates": "CO2-Zertifikate",
"Code": "Code",
"Coming Soon": "In K\u00fcrze verf\u00fcgbar",
"Commission Price": "Provisionspreis",
"Commission Share": "Provision Anteil",
"Companies": "Unternehmen",
"Companies for ": "Unternehmen f\u00fcr ",
"Companies for the corporate group: ": "Unternehmen der Unternehmensgruppe: ",
"Company": "Firma",
"Company Authenticity number": "Unternehmen Echtheitsnummer",
"Company Name": "Firmenname",
"Company No.": "Firmennr.",
"Company Number": "Handelsregisternummer",
"Company Roles": "Rollen im Unternehmen",
"Company Users for ": "Unternehmen Benutzer f\u00fcr ",
"Company name": "Firmenname",
"Company website": "Unternehmenswebseite",
"Compensation": "Verg\u00fctung",
"Confirm Email Address": "E-Mail Adresse best\u00e4tigen",
"Confirm Password": "Passwort best\u00e4tigen",
"Confirm Password is required": "Das Passwort muss best\u00e4tigt werden",
"Confirm password does not match.": "Passwort Best\u00e4tigung passt nicht.",
"Confirmation": "Best\u00e4tigung",
"Congratulations, you\u2019ve chosen the best energy spending platform": "Herzlichen Gl\u00fcckwunsch, Sie haben die beste Plattform f\u00fcr Energieausgaben gew\u00e4hlt",
"Consent": "Zustimmung",
"Consumption": "Verbrauch",
"Consumption (kWh)": "Verbrauch (kWh)",
"Consumption and CO\u2082e": "Verbrauch und CO\u2082-\u00c4quivalent",
"Consumption is kWh": "Verbrauch in kWh",
"Consumption measured in kWh": "Verbrauch gemessen in kWh",
"Contact Name": "Kontaktname",
"Contact Phone": "Kontakt Telefon",
"Continue": "Weiter",
"Contract list": "Liste der Vertr\u00e4ge",
"Contracts": "Vertr\u00e4ge",
"Conversion Rate": "Conversion-Rate",
"Conversion Rate for CO\u2082e": "Umwandlungssatz f\u00fcr CO\u2082e",
"Conversion rate in g CO\u2082e/kWh": "Umwandlungssatz in g CO\u2082e/kWh",
"Copied to clipboard": "In Zwischenablage kopiert",
"Corporate Group": "Unternehmensgruppe",
"Corporate Groups": "Unternehmensgruppen",
"Corporate Groups for the partner ": "Unternehmensgruppen f\u00fcr den Partner ",
"Corporate group and above level access": "Zugriff auf Konzernebene und dar\u00fcber",
"Cost": "Kosten",
"Cost (DKK)": "Kosten (DKK)",
"Cost in DKK": "Kosten in DKK",
"Country": "Land",
"Country code": "L\u00e4ndercode",
"Country, Timezone and Corporate Group is Required!": "Land, Zeitzone und Unternehmensgruppe sind erforderlich!",
"Create New Contract": "Neuen Vertrag erstellen",
"Create a new password": "Erstellen Sie ein neues Kennwort",
"Create or get an API key to access your data.": "Erstellen oder erhalten Sie einen API-Schl\u00fcssel f\u00fcr den Zugriff auf Ihre Daten.",
"Created At": "Erstellt am",
"Created By": "Erstellt von",
"Currency": "W\u00e4hrung",
"Currency is required": "W\u00e4hrung ist erforderlich",
"Current Password": "Aktuelles Passwort",
"Current month only": "Nur aktueller Monat",
"Current year only": "Nur laufendes Jahr",
"Customer": "Debitor",
"DKK": "DKK",
"Daily": "T\u00e4glich",
"Danish": "D\u00e4nisch",
"Data Delivered By": "Date geliefert von",
"Data granularity. PT1H = every 1 hour, PT15M = every 15 minutes": "Granularit\u00e4t der Daten. PT1H = alle 1 Stunde, PT15M = alle 15 Minuten",
"Data is currently being loaded. Please hold on a moment.": "Die Daten werden gerade geladen. Bitte warten Sie einen Moment.",
"Data validation - consumption": "Datenvalidierung - Verbrauch",
"DataHub": "DataHub",
"Date": "Datum",
"Date when the access is given": "Datum, an dem der Zugang gew\u00e4hrt wird",
"Day": "Tag",
"Days": "Tage",
"Dear {{user_full_name}}": "Liebe {{user_full_name}}",
"Dec": "Dez",
"Dec: Checking": "Dez: Kontrolle",
"Dec: Get": "Dez: Abrufen",
"Dec: Update": "Dez: Aktualisierung",
"December": "Dezember",
"Delete": "L\u00f6schen",
"Delete API Key": "API-Schl\u00fcssel l\u00f6schen",
"Deleted": "Gel\u00f6scht",
"Description": "Beschreibung",
"Developer": "Entwickler",
"Did you forget your password? Create a new one by clicking the button below.": "Haben Sie Ihr Passwort vergessen? Erstellen Sie ein neues, indem Sie auf die Schaltfl\u00e4che unten klicken.",
"Did you get this email by mistake? If so no worries - you can just ignore it.": "Haben Sie diese E-Mail versehentlich erhalten? Wenn ja, keine Sorge - Sie k\u00f6nnen sie einfach ignorieren.",
"Difference": "Differenz",
"Discount Net Tariff": "Discount-Netto-Tarif",
"Discount Subscription": "Rabatt-Abo",
"Distribution": "Vertrieb",
"District Heating": "Fernw\u00e4rme",
"Do you know?": "Kennen Sie das?",
"Do you want to delete the document?": "M\u00f6chten Sie das Dokument l\u00f6schen?",
"Do you want to delete the notification?": "M\u00f6chten Sie die Benachrichtigung l\u00f6schen?",
"Do you want to unlink the company?": "Wollen Sie das Unternehmen abkoppeln?",
"Do you want to unlink the user?": "M\u00f6chten Sie die Verkn\u00fcpfung des Benutzers aufheben?",
"Document Details": "Dokumentdetails",
"Document For": "Dokument f\u00fcr",
"Document Preview": "DokumentenVorschau",
"Document Type": "Belegart",
"Document Uploading Failed": "Hochladen von Dokumenten fehlgeschlagen",
"Document deleted successfully": "Dokument erfolgreich gel\u00f6scht",
"Document list": "Liste der Dokumente",
"Document not found": "Dokument nicht gefunden",
"Document updated successfully": "Dokument erfolgreich aktualisiert",
"Document uploaded successfully": "Dokument erfolgreich hochgeladen",
"Documents": "Dokumente",
"Don't Have An Account Yet?": "Sie haben noch kein Konto?",
"Download": "Download",
"Download Climate Report": "Download Klimabericht",
"Download Cost Report": "Kostenbericht herunterladen",
"Download Document": "Dokument herunterladen",
"Download Energy Report": "Energiebericht herunterladen",
"Download For App": "Herunterladen f\u00fcr App",
"Download For WWW": "Herunterladen f\u00fcr WWW",
"Download Sport Price Report": "Download Sport Preisbericht",
"Download report": "Bericht herunterladen",
"Drag and drop files here or click": "Ziehen Sie Dateien hierher oder klicken Sie",
"Drop the file here or": "Legen Sie die Datei hier ab oder",
"Dutch": "Niederl\u00e4ndisch",
"EPAD": "EPAD",
"EPAD Price": "EPAD-Preis",
"EPAD Share": "EPAD-Aktie",
"EPAD Type": "EPAD-Typ",
"EPAD kWh": "EPAD kWh",
"Edit": "Bearbeiten",
"Edit Contract": "Vertrag bearbeiten",
"Edit Corporate Group": "Unternehmensgruppe bearbeiten",
"Edit Document Details": "Dokumentdetails bearbeiten",
"Edit Feature": "Funktion bearbeiten",
"Edit Module": "Module bearbeiten",
"Edit Partner": "Partner bearbeiten",
"Edit Role": "Rolle bearbeiten",
"Edit Subscription": "Abonnement bearbeiten",
"Edit User": "Benutzer bearbeiten",
"Edit User Company": "Benutzer Firma bearbeiten",
"Effect Payment": "Effekt Zahlung",
"Effortless energy insights at your fingertips": "M\u00fchelose Energieeinblicke auf Knopfdruck",
"Electricity": "Strom",
"Electricity Charge": "Elektrizit\u00e4tsabgabe",
"Electricity consumption": "Stromverbrauch",
"Email": "E-Mail",
"Email Not Verified": "E-Mail-Adresse noch nicht \u00fcberpr\u00fcft",
"Email Sent ": "E-Mail gesendet ",
"Email address": "E-Mail-Adresse",
"Email is required.": "E-Mail ist erforderlich.",
"End": "Ende",
"End Date": "Enddatum",
"Energy": "Energie",
"Energy Consumption (kWh)": "Energieverbrauch (kWh)",
"Energy Contract": "Energievertrag",
"Energy Type": "Energieart",
"Energy report": "Energiebericht",
"Energy type is required": "Energieart ist erforderlich",
"English": "Englisch",
"Enter description": "Beschreibung eingeben",
"Enter email": "E-Mail eingeben",
"Enter email address": "Email Adresse eingeben",
"Enter email address to continue.": "Geben Sie Ihre E-Mail-Adresse ein, um fortzufahren.",
"Enter full name": "Vollst\u00e4ndigen eingeben",
"Enter name": "Namen eingeben",
"Enter password": "Passwort eingeben",
"Enter password again": "Passwort Wiederholung",
"Enter your new password to reset": "Geben Sie Ihr neues Passwort ein, um es zur\u00fcckzusetzen",
"Error loading image:": "Fehler beim Laden des Bildes:",
"Error: Something went wrong!": "Fehler: Etwas ist schief gelaufen!",
"Error: Something went wrong! ": "Fehler: Etwas ist schief gelaufen! ",
"Excel Reports": "Excel-Berichte",
"Excel Update": "Excel-Aktualisierung",
"Expire At": "Verfallen am",
"Export": "Export",
"Fabeke": "Fabeke",
"Fabeke Data": "Fabeke Daten",
"Fabeke follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.": "Fabeke verwendet standardm\u00e4\u00dfig Protokolldateien. Diese Dateien protokollieren die Besuche von Besuchern auf Websites. Alle Hosting-Unternehmen tun dies und es ist Teil der Analyse der Hosting-Dienste. Zu den in den Protokolldateien gesammelten Informationen geh\u00f6ren Internetprotokolladressen (IP), Browsertyp, Internetdienstanbieter (ISP), Datums- und Zeitstempel, verweisende/verlassende Seiten und m\u00f6glicherweise die Anzahl der Klicks. Diese Daten werden nicht mit Informationen verkn\u00fcpft, die eine pers\u00f6nliche Identifizierung erm\u00f6glichen. Der Zweck dieser Informationen ist die Analyse von Trends, die Verwaltung der Website, die Verfolgung der Bewegungen der Nutzer auf der Website und die Erfassung demografischer Informationen.",
"Fabeke's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.": "Die Datenschutzrichtlinie von Fabeke gilt nicht f\u00fcr andere Werbetreibende oder Websites. Wir raten Ihnen daher, die jeweiligen Datenschutzrichtlinien dieser Werbeserver Dritter zu konsultieren, um genauere Informationen zu erhalten. Diese k\u00f6nnen deren Praktiken und Anweisungen dar\u00fcber enthalten, wie Sie bestimmte Optionen deaktivieren k\u00f6nnen.",
"Failed to delete document": "Dokument konnte nicht gel\u00f6scht werden",
"Failed to load document preview. Please try downloading the document.": "Die Dokumentvorschau konnte nicht geladen werden. Bitte versuchen Sie, das Dokument herunterzuladen.",
"Failed to unlink. ": "Entkopplung fehlgeschlagen. ",
"Feature": "Feature",
"Feature Name": "Eigenschaft Name",
"Feature key, Alpha numeric and dash only": "Funktionstaste, nur alphanumerische Zeichen und Bindestrich",
"Features": "Features",
"Features for ": "Merkmale f\u00fcr ",
"Feb": "Feb",
"Feb: Checking": "Februar: \u00dcberpr\u00fcfung von",
"Feb: Get": "Februar: Abrufen",
"Feb: Update": "Feb: Update",
"February": "Februar",
"Feel free to reach out to Customer Service. They are around 24/7 to help you.": "Sie k\u00f6nnen sich jederzeit an den Kundendienst wenden. Er ist rund um die Uhr f\u00fcr Sie da.",
"File Name": "Dateiname",
"File type not supported": "Dateityp nicht unterst\u00fctzt",
"Fixed": "Fixiert",
"Fixed Price": "Festpreis",
"Fixed price": "Festpreis",
"Fixed price ex epad": "Festpreis ex epad",
"Fixed price ex epad and profile": "Festpreis ab Epad und Profil",
"Fixed price ex profile": "Festpreis ab Profil",
"Fixed profile ex spot": "Festes Profil ab Spot",
"Forgot Password": "Passwort vergessen",
"Forgot Your Password?": "Passwort vergessen?",
"Forgot your password?": "Passwort vergessen?",
"French": "Franz\u00f6sisch",
"From": "Von",
"From date is required": "Von-Datum ist erforderlich",
"Full Name": "Vollst\u00e4ndiger Name",
"Full Year": "Ganzes Jahr",
"Gain control of your energy spending": "Gewinnen Sie die Kontrolle \u00fcber Ihre Energieausgaben",
"Gas": "Gas",
"Generate API Key": "API-Schl\u00fcssel generieren",
"Generate Climate Report": "Klimabericht generieren",
"Generate Cost Report": "Kostenbericht generieren",
"Generate Email": "E-Mail generieren",
"Generate Energy Report": "Energiebericht generieren",
"Generating Excel file": "Erzeugen einer Excel-Datei",
"German": "Deutsch",
"Get Full Visibility Over Your Energy Spending With Less Manual Work": "Volle Transparenz \u00fcber Ihre Energieausgaben mit weniger manueller Arbeit",
"Go to App": "Zur App gehen",
"Green Certificates": "Gr\u00fcne Zertifikate",
"Green Electricity": "Gr\u00fcne Elektrizit\u00e4t",
"Grid company": "Netzgesellschaft",
"Heating": "Heizung",
"Historical Data": "Historische Daten",
"Hour": "Stunde",
"Hourly": "St\u00fcndlich",
"Hours": "Stunden",
"House No.": "Hausnummer",
"How many buildings company have": "Wie viele Geb\u00e4ude hat das Unternehmen",
"How many meters company have": "Wie viele Z\u00e4hler hat das Unternehmen",
"I agree with": "Ich stimme zu",
"ID": "ID",
"If the data is heavy, it may still be loading.": "Wenn es sich um gro\u00dfe Datenmengen handelt, werden sie m\u00f6glicherweise noch geladen.",
"InActive": "InAktiv",
"Installation Numbers": "Installations-Nummern",
"Installation number": "Installationsnummer",
"Installation number is required": "Installationsnummer ist erforderlich",
"Internet connection restored": "Internetverbindung wiederhergestellt",
"Interval": "Intervall",
"Invite User": "Benutzer einladen",
"Invoice": "Rechnung",
"Invoices": "Rechnungen",
"It will download a zip file containing the PO and POT files. PO file will have the existing translations, and the POT file will have the latest text that requires translation. We can use the Poedit software to import the POT text into the PO file and translate it.": "Es wird eine Zip-Datei heruntergeladen, die die PO- und POT-Dateien enth\u00e4lt. Die PO-Datei enth\u00e4lt die vorhandenen \u00dcbersetzungen und die POT-Datei den neuesten Text, der \u00fcbersetzt werden muss. Wir k\u00f6nnen die Software Poedit verwenden, um den POT-Text in die PO-Datei zu importieren und ihn zu \u00fcbersetzen.",
"Item": "Artikel",
"Items": "Artikel",
"Jan": "Jan",
"Jan: Checking": "Jan: \u00dcberpr\u00fcfen",
"Jan: Get": "Jan: Abrufen",
"Jan: Update": "Jan: Aktualisierung",
"January": "Januar",
"Jul": "Jul",
"Jul: Checking": "Jul: \u00dcberpr\u00fcfung von",
"Jul: Get": "Jul: Abrufen",
"Jul: Update": "Jul: Aktualisierung",
"July": "Juli",
"Jun": "Jun",
"Jun: Checking": "Jun: \u00dcberpr\u00fcfung von",
"Jun: Get": "Jun: Abrufen",
"Jun: Update": "Jun: Aktualisierung",
"June": "Juni",
"Key": "Schl\u00fcssel",
"Key, Alpha numeric and dash only": "Taste, nur Alphanumerik und Bindestrich",
"Kg of CO\u2082e": "Kg CO\u2082e",
"Kilogram": "Kilogramm",
"LNG": "Fl\u00fcssigerdgas",
"Language": "Sprache",
"Languages": "Sprachen",
"Last Login": "Letzte Anmeldung",
"Last date": "Letztes Datum",
"Last seen": "Zuletzt gesehen",
"Like any other website, Fabeke uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.": "Wie jede andere Website verwendet auch Fabeke \"Cookies\". Diese Cookies werden verwendet, um Informationen zu speichern, einschlie\u00dflich der Pr\u00e4ferenzen der Besucher und der Seiten auf der Website, die der Besucher aufgerufen oder besucht hat. Die Informationen werden verwendet, um die Erfahrung des Benutzers zu optimieren, indem der Inhalt unserer Webseite auf der Grundlage des Browsertyps des Besuchers und/oder anderer Informationen angepasst wird.",
"Link": "Link",
"Link User": "Benutzer Verkn\u00fcpfen",
"Link company": "Link Unternehmen",
"Link user": "Benutzer verkn\u00fcpfen",
"List View": "Listenansicht",
"List as": "Auflisten als",
"Loading": "Laden",
"Loading security verification...": "Sicherheits\u00fcberpr\u00fcfung wird geladen...",
"Loading...": "Lade...",
"Location": "Standort",
"Location and above level access": "Lage und ebenerdiger Zugang",
"Login": "Anmelden",
"Login as": "Anmelden als",
"Login code": "Login-Code",
"Login failed! Please try again": "Anmeldung fehlgeschlagen! Bitte versuchen Sie es erneut",
"Login successful. Redirecting.": "Anmeldung erfolgreich. Weiterleitung.",
"Login with your new password right away.": "Melden Sie sich sofort mit Ihrem neuen Passwort an.",
"Main Price Type": "Hauptpreis Typ",
"Mar": "M\u00e4r",
"Mar: Checking": "Mar: \u00dcberpr\u00fcfen Sie",
"Mar: Get": "Mar: Abrufen",
"Mar: Update": "Mar: Update",
"March": "M\u00e4rz",
"Mark As Read": "Als gelesen markieren",
"Markup": "Markup",
"Markup Price": "Aufschlag Preis",
"Markup Share": "Markup-Anteil",
"Max size supported 20MB": "Maximal unterst\u00fctzte Gr\u00f6\u00dfe 20 MB",
"Maximum 50 symbols": "Maximal 50 Symbole",
"May": "Mai",
"May: Checking": "Mai: \u00dcberpr\u00fcfung von",
"May: Get": "Mai: Abrufen",
"May: Update": "Mai: Update",
"Message": "Mitteilung",
"Meter": "Meter",
"Meter No": "Z\u00e4hler Nr",
"Meter and above level access": "Z\u00e4hler und Zugang \u00fcber dem Niveau",
"Meter number": "Z\u00e4hlernummer",
"Meter reading end date": "Enddatum der Ablesung",
"Meter reading start date": "Datum des Beginns der Ablesung",
"Minimum 3 symbols": "Mindestens 3 Symbole",
"Minimum Fee": "Mindestgeb\u00fchr",
"Modals": "Modale",
"Module": "Modul",
"Module code, Alpha numeric and dash only": "Modulcode, nur alphanumerische Zeichen und Bindestrich",
"Module name": "Name des Moduls",
"Month": "Monat",
"Month Columns: Downloading": "Monatskolumnen: Herunterladen",
"Month Columns: Processing": "Monatsspalten: Verarbeitung",
"Month Data: Downloading": "Monatsdaten: Herunterladen von",
"Month Data: Processing": "Monatliche Daten: Verarbeitung",
"Monthly": "Monatlich",
"Monthly Statement": "Monatlicher Auszug",
"Months": "Monate",
"Must be a valid email": "Muss eine g\u00fcltige E-Mail sein",
"My Account": "Mein Konto",
"My Companies": "Meine Unternehmen",
"My Profile": "Mein Profil",
"Name": "Name",
"Name is required.": "Ihr Name ist erforderlich.",
"Natural Gas": "Erdgas",
"Net": "Netto",
"Net Tariff": "Netto-Tarif",
"Never Login": "Niemals anmelden",
"New Password": "Neues Passwort",
"New Password is required": "Neues Passwort ist erforderlich",
"No": "Nein",
"No Company": "Keine Firma",
"No Documents Found": "Keine Dokumente gefunden",
"No Historical Data Limit": "Keine Begrenzung der historischen Daten",
"No Limit": "Keine Begrenzung",
"No Partner": "Partner USt-IdNr",
"No Results Found!": "Keine Ergebnisse gefunden!",
"No Rows": "Keine Zeilen",
"No data found": "Keine Daten gefunden",
"No document available for preview": "Kein Dokument f\u00fcr die Vorschau verf\u00fcgbar",
"No internet connection. Please check your network.": "Keine Internetverbindung. Bitte \u00fcberpr\u00fcfen Sie Ihr Netzwerk.",
"No option available": "Keine Option verf\u00fcgbar",
"No use of Fabeke's logo or other artwork will be allowed for linking absent a trademark license agreement.": "Die Verwendung des Fabeke-Logos oder anderer Grafiken f\u00fcr die Verlinkung ist ohne eine Markenlizenzvereinbarung nicht gestattet.",
"Norwegian": "Norwegisch",
"Not Applicable": "Nicht zutreffend",
"Not Found": "Nicht gefunden",
"Notes": "Notizen",
"Notification has been deleted": "Benachrichtigung wurde gel\u00f6scht",
"Notification marked as read": "Benachrichtigung als \"Gelesen\" markiert",
"Notifications": "Benachrichtigungen",
"Nov": "Nov",
"Nov: Checking": "Nov: \u00dcberpr\u00fcfung von",
"Nov: Get": "Nov: Abrufen",
"Nov: Update": "Nov: Aktualisierung",
"November": "November",
"Oct": "Okt",
"Oct: Checking": "Okt: \u00dcberpr\u00fcfung von",
"Oct: Get": "Okt: Abrufen",
"Oct: Update": "Okt: Update",
"October": "Oktober",
"Official address of meter (not including location information)": "Offizielle Adresse des Z\u00e4hlers (ohne Angaben zum Standort)",
"Often the number on company's bill": "Oft die Nummer auf der Rechnung des Unternehmens",
"Oil": "\u00d6l",
"One Month Energy Consumption (kWh)": "Energieverbrauch eines Monats (kWh)",
"One Month Tariff (kWh)": "Tarif f\u00fcr einen Monat (kWh)",
"Only PDF files are allowed.": "Es sind nur PDF-Dateien erlaubt.",
"Only PDF files are allowed. Leave empty to keep the existing file.": "Es sind nur PDF-Dateien zul\u00e4ssig. Lassen Sie das Feld leer, um die vorhandene Datei beizubehalten.",
"Only for system level users": "Nur f\u00fcr Benutzer auf Systemebene",
"Only lowercase alphanumeric characters and dashes are allowed": "Nur alphanumerische Kleinbuchstaben und Bindestriche sind erlaubt",
"Order No": "Auftrag-Nr",
"Order Numbers": "Bestellnummern",
"Others": "Andere",
"Overall statement": "Gesamtaussage",
"Parameter showing Electricity consumption": "Parameter f\u00fcr den Stromverbrauch",
"Parent Company": "Mutterkonzern",
"Parent company and above level access": "Zugriff auf die Muttergesellschaft und \u00fcbergeordnete Ebenen",
"Partner": "Partner",
"Partner Users for ": "Partner Benutzer f\u00fcr ",
"Partner and above level access": "Zugriff f\u00fcr Partner und h\u00f6here Ebenen",
"Partners": "Partner",
"Partnerships Team": "Team Partnerschaften",
"Password": "Passwort *",
"Password Changed": "Passwort ge\u00e4ndert",
"Passwords didn't match": "Passw\u00f6rter stimmten nicht \u00fcberein",
"Period/Sum": "Zeitraum/Summe",
"Permissions": "Berechtigungen",
"Permissions for ": "berechtigungen f\u00fcr ",
"Personal": "Pers\u00f6nlich",
"Personal Information": "Pers\u00f6nliche Informationen",
"Please also note to calculate the emission rate from CO2, the 125% method is used, which means that coproduced heat is produced by a given efficiency by 125%.": "Bitte beachten Sie auch, dass f\u00fcr die Berechnung der CO2-Emissionsrate die 125%-Methode verwendet wird, was bedeutet, dass die koproduzierte W\u00e4rme bei einem bestimmten Wirkungsgrad zu 125% produziert wird.",
"Please authorize us on": "Bitte autorisieren Sie uns am",
"Please enter a valid email and password!": "Bitte geben Sie eine g\u00fcltige E-Mail-Adresse und ein g\u00fcltiges Passwort ein!",
"Please enter a valid email!": "Bitte geben Sie eine g\u00fcltige E-Mail-Adresse ein!",
"Please enter a valid password!": "Bitte geben Sie ein g\u00fcltiges Passwort ein!",
"Please select a file to upload": "Bitte w\u00e4hle eine Datei zum Hochladen aus",
"Please wait": "Bitte warten",
"Please wait while security verification loads...": "Bitte warten Sie, w\u00e4hrend die Sicherheits\u00fcberpr\u00fcfung geladen wird...",
"Price": "Preis",
"Price (cent/kWh)": "Preis (Cent/kWh)",
"Price (pence/kWh)": "Preis (Pence/kWh)",
"Price (\u00d8re/kWh)": "Preis (\u00d8re/kWh)",
"Price (\u00f8re/kWh)": "Preis (\u00f8re/kWh)",
"Price Price": "Preis Preis",
"Price Share": "Preis Aktie",
"Price Type": "Preis Typ",
"Price elements": "Preis-Elemente",
"Price in (\u00d8re/kWh)": "Preis in (\u00d8re/kWh)",
"Price kWh": "Preis kWh",
"Price type": "Preistyp",
"Price type is required": "Preisart ist erforderlich",
"Prices": "Preise",
"Privacy Policy": "Datenschutzerkl\u00e4rung",
"Privacy Policy for Fabeke": "Datenschutzrichtlinie f\u00fcr Fabeke",
"Procurement": "Datenschutzbestimmung",
"Profile": "Profil",
"Profile Price": "Profil Preis",
"Profile Share": "Profil Aktie",
"Profile Type": "Profiltyp",
"Profile kWh": "Profil kWh",
"Q1": "Q1",
"Q2": "Q2",
"Q3": "Q3",
"Q4": "Q4",
"Quantity (kWh)": "Menge (kWh)",
"Questions?": "Fragen?",
"Rabat Net Tariff": "Rabat Netto-Tarif",
"Read Notification": "Mitteilung gelesen",
"Ready to enhance your offering? Talk to someone from our partnerships team today & start using ": "Sind Sie bereit, Ihr Angebot zu erweitern? Sprechen Sie noch heute mit einem Mitglied unseres Partnerschafts-Teams und nutzen Sie ",
"Real-time, precise, and automated.": "In Echtzeit, pr\u00e4zise und automatisiert.",
"Recover Password": "Passwort wiederherstellen",
"Registered successful. Redirecting.": "Erfolgreich registriert. Umleitung.",
"Remove file": "Datei entfernen",
"Report": "Melden",
"Reports": "Berichte",
"Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.": "Verlangen Sie, dass ein Unternehmen, das personenbezogene Daten eines Verbrauchers sammelt, die Kategorien und spezifischen Teile der personenbezogenen Daten offenlegt, die das Unternehmen \u00fcber den Verbraucher gesammelt hat.",
"Request that a business that sells a consumer's personal data, not sell the consumer's personal data.": "Verlangen Sie, dass ein Unternehmen, das die pers\u00f6nlichen Daten eines Verbrauchers verkauft, die pers\u00f6nlichen Daten des Verbrauchers nicht verkauft.",
"Require all devices to sign in again with the new password.": "Fordern Sie alle Ger\u00e4te auf, sich erneut mit dem neuen Kennwort anzumelden.",
"Reset Completed": "Zur\u00fccksetzen Beendet",
"Reset Password": "Passwort zur\u00fccksetzen",
"Reset Your Password": "Passwort zur\u00fccksetzen",
"Role": "Rolle",
"Role key, Alpha numeric and dash only": "Rollenschl\u00fcssel, nur Alphanumerik und Bindestrich",
"Roles": "Rollen",
"Save": "Speichern",
"Save All For": "Alle speichern f\u00fcr",
"Save Changes": "\u00c4nderungen speichern",
"Save Profile": "Profil speichern",
"Saving. Please wait.": "Sparen. Bitte warten Sie.",
"Scraper List": "Abstreifer Liste",
"Scraper Log": "Kratzbaum",
"Scraper Name": "Name des Abstreifers",
"Search": "Suche",
"See All Notifications": "Alle Benachrichtigungen anzeigen",
"Select": "Ausw\u00e4hlen",
"Select Company": "Firma ausw\u00e4hlen",
"Select date range": "Datumsbereich ausw\u00e4hlen",
"Select your locality": "W\u00e4hlen Sie Ihren Standort",
"Send Link to Email": "Link per E-Mail senden",
"Send the user a notification via email.": "Senden Sie dem Benutzer eine Benachrichtigung per E-Mail.",
"Sep": "Sep",
"Sep: Checking": "Sep: \u00dcberpr\u00fcfung von",
"Sep: Get": "Sep: Abrufen",
"Sep: Update": "Sep: Update",
"September": "September",
"Settings": "Einstellungen",
"Setup a unique password to protect your account.": "Richten Sie ein eindeutiges Passwort ein, um Ihr Konto zu sch\u00fctzen.",
"Share": "Teilen",
"Share (%)": "Anteil (%)",
"Show up to": "Auftauchen bei",
"Sign In": "Anmelden",
"Sign Out": "Abmelden",
"Sign Up": "Registrieren",
"Sign in": "Anmelden",
"Sign up": "Registrieren",
"Simple": "Einfach",
"Spanish": "Spanisch",
"Spot (60%)": "Punkt (60%)",
"Spot Premium Price": "Spot Pr\u00e4mie",
"Spot Premium Share": "Spot Pr\u00e4mie Anteil",
"Spot Price": "Kassapreis",
"Spot Prices": "Spotpreise",
"Spot premium": "Spot Pr\u00e4mie",
"Spotpris": "Spotpris",
"Start": "Start",
"Start Date": "Startdatum",
"Statement": "Auszug",
"Statement Export": "Erkl\u00e4rung Export",
"Status": "Status",
"Still Loading": "Wird noch geladen",
"Street": "Stra\u00dfe",
"Submit": "Senden",
"Subscription": "Abonnement",
"Subscription Expire At": "Abonnement l\u00e4uft ab am",
"Subscription Expired!": "Abonnement abgelaufen!",
"Subscription Expiring Soon!": "Abonnement l\u00e4uft bald ab!",
"Subscription Plan": "Mitgliedschaft",
"Subscription Plan Name": "Name des Abonnementplans",
"Subscription Plan added Successfully": "Abonnementplan erfolgreich hinzugef\u00fcgt",
"Subscription Plans": "Abo-Pl\u00e4ne",
"Subscription key, Alpha numeric and dash only": "Abonnementschl\u00fcssel, nur alphanumerische Zeichen und Bindestriche",
"Subscription updated Successfully": "Abonnement erfolgreich aktualisiert",
"Sum": "Summe",
"Sum/Average": "Summe/Durchschnitt",
"Support": "Support",
"Swedish": "Schwedisch",
"Switch as": "Schalter als",
"System": "System",
"System Price": "System Preis",
"System Roles": "Systemrollen",
"System Share": "System-Anteil",
"System Tariff": "System-Tarif",
"System Type": "Systemtyp",
"System Users": "Systembenutzer",
"System kWh": "System kWh",
"TSO - System Subscription": "TSO - System-Abonnement",
"Take control of your energy expenses with": "\u00dcbernehmen Sie die Kontrolle \u00fcber Ihre Energiekosten mit",
"Tariff": "Tarif",
"Tax": "Steuer",
"Taxes (\u00d8re/kWh)": "Steuern (\u00d8re/kWh)",
"Taxes in (\u00d8re/kWh)": "Steuern in (\u00d8re/kWh)",
"Tenants": "Mieter",
"Terms & Conditions": "Allgemeine Gesch\u00e4ftsbedingungen",
"Test Climate Report": "Test Klimabericht",
"Test Energy Report": "Test Energiebericht",
"Test Sport Price Report": "Test Sport Preisbericht",
"Test report": "Testbericht",
"Thank you for registering with us. We're excited to have you on board!": "Vielen Dank, dass Sie sich bei uns angemeldet haben. Wir freuen uns, Sie an Bord zu haben!",
"Thanks for signing up!": "Danke f\u00fcr's Registrieren!",
"That is great that you know that.": "Es ist toll, dass Sie das wissen.",
"The POC has been updated.": "Der POC wurde aktualisiert.",
"The cache has been cleared": "Der Cache wurde geleert",
"The calculations for the CO2 emissions are based on emissions from each power plant above 10MW and where all power plants below 10MW is regarded as one power plant. Furthermore, the calculations are based on production per hour, consumption per hour and exchange per hour.": "Die Berechnungen f\u00fcr die CO2-Emissionen basieren auf den Emissionen jedes Kraftwerks \u00fcber 10 MW, wobei alle Kraftwerke unter 10 MW als ein Kraftwerk betrachtet werden. Au\u00dferdem basieren die Berechnungen auf der Produktion pro Stunde, dem Verbrauch pro Stunde und dem Austausch pro Stunde.",
"The company already linked.": "Das Unternehmen ist bereits verlinkt.",
"The company has been linked.": "Das Unternehmen ist miteinander verbunden.",
"The company has been unlinked.": "Das Unternehmen wurde entflochten.",
"The data limit has been updated": "Die Datengrenze wurde aktualisiert",
"The deal has updated": "Das Gesch\u00e4ft hat aktualisiert",
"The document has been uploaded.": "Das Dokument wurde hochgeladen.",
"The email has been sent": "Die E-Mail wurde gesendet",
"The file has been exported.": "Die Datei ist exportiert worden.",
"The mail already exists in the system!": "Die Mail ist bereits im System vorhanden!",
"The metering point id from datahub": "Die Messstellen-ID von datahub",
"The module has been updated": "Das Modul wurde aktualisiert",
"The new POC has been added.": "Der neue POC wurde hinzugef\u00fcgt.",
"The new deal has added": "Mit dem neuen Abkommen wurde Folgendes hinzugef\u00fcgt",
"The new feature has been added": "Die neue Funktion wurde hinzugef\u00fcgt",
"The new module has been added": "Das neue Modul wurde hinzugef\u00fcgt",
"The new partner has been added.": "Der neue Partner wurde hinzugef\u00fcgt.",
"The new role has been added.": "Die neue Rolle ist hinzugef\u00fcgt worden.",
"The new user has been added.": "Der neue Benutzer wurde hinzugef\u00fcgt.",
"The partner has been updated.": "Der Partner wurde aktualisiert.",
"The password has been reset.": "Dein Passwort wurde zur\u00fcckgesetzt.",
"The password has been updated.": "Das Passwort wurde aktualisiert.",
"The registration is by invitation only.": "Die Registrierung erfolgt nur auf Einladung.",
"The role has been updated": "Die Rolle wurde aktualisiert",
"The session has been expired.": "Die Sitzung ist abgelaufen.",
"The system is now creating the report, and you can download it shortly by clicking Download.": "Das System erstellt nun den Bericht und Sie k\u00f6nnen ihn in K\u00fcrze herunterladen, indem Sie auf Download klicken.",
"The user already linked.": "Der Benutzer ist bereits verlinkt.",
"The user has been linked.": "Der Benutzer ist verlinkt worden.",
"The user has been unlinked.": "Der Benutzer wurde entkoppelt.",
"The user has been updated": "Der Benutzer wurde aktualisiert",
"The year cache has been updated": "Der Jahres-Cache ist aktualisiert worden",
"There are no documents matching your criteria.": "Es gibt keine Dokumente, die Ihren Kriterien entsprechen.",
"These terms and conditions outline the rules and regulations for the use of Fabeke's Website, located at https://www.fabeke.com": "Diese Bedingungen beschreiben die Regeln und Vorschriften f\u00fcr die Nutzung der Website von Fabeke, die sich unter https://www.fabeke.com befindet",
"Third Party Privacy Policies": "Datenschutzrichtlinien von Dritten",
"Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Fabeke, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.": "Werbeserver oder Werbenetzwerke von Drittanbietern verwenden Technologien wie Cookies, JavaScript oder Web Beacons, die in ihren jeweiligen Anzeigen und Links, die auf Fabeke erscheinen, verwendet werden und direkt an den Browser des Nutzers gesendet werden. In diesem Fall erhalten sie automatisch Ihre IP-Adresse. Diese Technologien werden verwendet, um die Wirksamkeit ihrer Werbekampagnen zu messen und/oder die Werbeinhalte, die Sie auf den von Ihnen besuchten Websites sehen, zu personalisieren.",
"This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!": "Dies ist eine Vorwarnung f\u00fcr alle! Wir haben die Neuanmeldungen vor\u00fcbergehend pausiert. Aber keine Sorge, wir werden sie in K\u00fcrze wieder \u00f6ffnen. Bleibt dran!",
"Thumbnail View": "Miniaturansicht (Thumbnail View)",
"Time Zone": "Zeitzone",
"Timestamp of last encountered when requesting data from datahub": "Zeitstempel des letzten Treffens bei der Abfrage von Daten von datahub",
"Timezone": "Zeitzone",
"To": "Bis",
"To complete your registration and activate your account, please confirm your email address by clicking the below:": "Um Ihre Registrierung abzuschlie\u00dfen und Ihr Konto zu aktivieren, best\u00e4tigen Sie bitte Ihre E-Mail-Adresse, indem Sie auf das folgende Feld klicken:",
"To date is required": "Bis heute ist erforderlich",
"To ensure the data is tailored to your local time, we require your": "Um sicherzustellen, dass die Daten auf Ihre Ortszeit zugeschnitten sind, ben\u00f6tigen wir Ihre",
"Total Electricity Charge": "Elektrizit\u00e4tskosten insgesamt",
"Translation": "\u00dcbersetzung",
"Transmission Grid Tariff": "Tarif f\u00fcr das \u00dcbertragungsnetz",
"Type": "Typ",
"Type of meter. E17 = consumption, E18 = production": "Typ des Z\u00e4hlers. E17 = Verbrauch, E18 = Erzeugung",
"URL": "URL",
"Under construction": "Im Aufbau",
"Unit": "Kapitel",
"Unknown Error Occurred !": "Unbekannter Fehler ist aufgetreten!",
"Unknown error1 Occurred !": "Unbekannter Fehler1 aufgetreten!",
"Unlink": "Trennen",
"Update": "Aktualisieren",
"Update Roles": "Rollen aktualisieren",
"Update failed": "Update fehlgeschlagen",
"Update your Image and other data here.": "Aktualisieren Sie hier Ihr Bild und andere Daten.",
"Updated At": "Aktualisiert am",
"Updating...": "Aktualisieren\u2026",
"Upload": "Hochladen",
"Upload Data": "Daten hochladen",
"Upload Document Files": "Dokumentdateien hochladen",
"Upload New Document": "Neues Dokument hochladen",
"Upload New Document File (Optional)": "Neue Dokumentdatei hochladen (optional)",
"Uploaded": "Hochgeladen",
"Uploading": "Wird hochgeladen",
"Uploading...": "Hochladen\u2026",
"Use this page to update the application version. Once you change the version, the client-side application will automatically download and run the latest code from the server.": "Auf dieser Seite k\u00f6nnen Sie die Version der Anwendung aktualisieren. Sobald Sie die Version \u00e4ndern, wird die clientseitige Anwendung automatisch den neuesten Code vom Server herunterladen und ausf\u00fchren.",
"User Data": "Benutzerdaten",
"User ID is missing": "Die Benutzer-ID fehlt",
"Users": "Benutzer",
"V_per_m2": "V_pro_m2",
"Validating period": "Validierungszeitraum",
"Validating. Please wait.": "Validierung l\u00e4uft. Bitte warten.",
"Validity end date": "Datum des G\u00fcltigkeitsendes",
"Validity start date": "Datum des G\u00fcltigkeitsbeginns",
"Variable/Spot/Nordpool price": "Variabler/Spot/Nordpool-Preis",
"Verification Successful": "Verifizierung erfolgreich",
"Verify Password": "Passwort best\u00e4tigen",
"Version": "Version",
"Version Management": "Version Management",
"View": "Anzeigen",
"View Mode": "Ansichts Modus",
"View meter details": "Details zum Messger\u00e4t anzeigen",
"Water": "Wasser",
"We are unable to find your email address": "Wir k\u00f6nnen Ihre E-Mail Adresse nicht finden",
"We couldn't find what you searched for": "Wir konnten nicht finden, wonach Sie gesucht haben",
"We employ the use of cookies. By accessing Fabeke, you agreed to use cookies in agreement with the Fabeke's Privacy Policy.": "Wir verwenden Cookies. Wenn Sie auf Fabeke zugreifen, stimmen Sie der Verwendung von Cookies in \u00dcbereinstimmung mit der Datenschutzrichtlinie von Fabeke zu.",
"We have updated the reports for last month, and you can download the reports by clicking below": "Wir haben die Berichte f\u00fcr den letzten Monat aktualisiert, und Sie k\u00f6nnen die Berichte herunterladen, indem Sie unten klicken",
"Website": "Webseite",
"Welcome to": "Willkommen bei",
"Welcome to ": "Willkommen bei ",
"What do you know?": "Was wei\u00dft du schon?",
"Wrong password!": "Falsches Kennwort!",
"Year": "Jahr",
"Year Data: Downloading": "Jahr Daten: Herunterladen von",
"Year Data: Processing": "Jahr Daten: Verarbeitung",
"Year: Get": "Jahr: Abrufen",
"Year: Update": "Jahr: Aktualisierung",
"Yearly": "J\u00e4hrlich",
"Years": "Jahre",
"Yes": "Ja",
"Yes I know that.": "Ja, das wei\u00df ich.",
"You are not authorized to perform this action": "Sie sind nicht berechtigt, diese Aktion auszuf\u00fchren",
"You can change your password here": "Ihr Passwort k\u00f6nnen Sie hier \u00e4ndern",
"You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser's respective websites.": "Sie k\u00f6nnen Cookies \u00fcber Ihre individuellen Browseroptionen deaktivieren. Ausf\u00fchrlichere Informationen zur Cookie-Verwaltung mit bestimmten Webbrowsern finden Sie auf den jeweiligen Websites der Browser.",
"You can continue to use our services now. ": "Sie k\u00f6nnen unsere Dienste jetzt weiter nutzen. ",
"You can now use your new password to sign in to your account.": "Sie k\u00f6nnen sich nun mit Ihrem neuen Passwort bei Ihrem Konto anmelden.",
"You can upload only the PO file. After uploading that file, it takes almost 10 minutes to reflect the changes on the website.": "Sie k\u00f6nnen nur die PO-Datei hochladen. Nachdem Sie diese Datei hochgeladen haben, dauert es fast 10 Minuten, bis die \u00c4nderungen auf der Website angezeigt werden.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Sie wurden von {{partner_name}} eingeladen, sich als {{role_name}} anzumelden. Um fortzufahren, klicken Sie auf \u201eAnmelden\u201c, um auf das System zuzugreifen.",
"You have invited by the {{partner_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Sie wurden von der {{partner_name}} eingeladen, als {{role_name}} beizutreten. Um fortzufahren, m\u00fcssen Sie ein Passwort f\u00fcr den Zugriff auf das System erstellen.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you click Login to access the system.": "Sie wurden von {{tenant_name}} eingeladen, sich als {{role_name}} anzumelden. Um fortzufahren, klicken Sie auf \u201eAnmelden\u201c, um auf das System zuzugreifen.",
"You have invited by the {{tenant_name}} to join as {{role_name}}. To continue, you must create a password to access the system.": "Sie wurden von der {{tenant_name}} eingeladen, als {{role_name}} beizutreten. Um fortzufahren, m\u00fcssen Sie ein Passwort f\u00fcr den Zugriff auf das System erstellen.",
"Your Picture": "Ihr Bild",
"Your account doesn\u2019t exist, please Sign Up": "Ihr Konto existiert nicht, bitte melden Sie sich an",
"Your login session has been expired. Please log in again": "Ihre Anmeldesitzung ist abgelaufen. Bitte melden Sie sich erneut an",
"Your password has been changed": "Ihr Passwort wurde ge\u00e4ndert",
"Your password has been successfully reset.": "Ihr Passwort wurde erfolgreich zur\u00fcckgesetzt.",
"Your private file": "Ihre private Datei",
"Your profile has been updated": "Dein Profil wurde aktualisiert",
"Your subscription has expired. Renew now to regain access to your account and all premium features.": "Ihr Abonnement ist abgelaufen. Verl\u00e4ngern Sie jetzt, um wieder Zugriff auf Ihr Konto und alle Premium-Funktionen zu erhalten.",
"Your subscription will expire in": "Ihr Abonnement l\u00e4uft in",
"Zip Code": "Postleitzahl",
"aggregated": "aggregiert",
"all": "Alle",
"and": "und",
"and Fabeke Tech does not take responsibility for any errors in submitted data and lists": "und Fabeke Tech \u00fcbernimmt keine Verantwortung f\u00fcr eventuelle Fehler in den eingereichten Daten und Listen",
"browse": "durchsuchen",
"cache has been updated": "der Cache wurde aktualisiert",
"clicking the link we just emailed you at ": "klicken Sie auf den Link, den wir Ihnen gerade per E-Mail geschickt haben ",
"collects your energy data, prices and carbon emissions from all relevant data sources and present your energy consumption, prices, taxes, costs, and carbon emissions in our energy spending platform.": "sammelt Ihre Energiedaten, Preise und Kohlendioxidemissionen aus allen relevanten Datenquellen und pr\u00e4sentiert Ihren Energieverbrauch, Ihre Preise, Steuern, Kosten und Kohlendioxidemissionen in unserer Plattform f\u00fcr Energieausgaben.",
"comprehensive data and insights": "umfassende Daten und Einblicke",
"contact us": "Kontaktieren Sie uns",
"converts data into your language and local time zone": "konvertiert Daten in Ihre Sprache und lokale Zeitzone",
"country, timezone and corporate group": "Land, Zeitzone und Unternehmensgruppe",
"export": "Export",
"export to CSV": "zu CSV exportieren",
"export to Excel": "nach Excel exportieren",
"export to PDF": "Als PDF exportieren",
"files": "Dateien",
"for any queries.": "f\u00fcr eventuelle R\u00fcckfragen.",
"g CO\u2082/kW": "g CO\u2082/kW",
"g CO\u2082e/kW": "g CO\u2082e/kW",
"gives you": "gibt Ihnen",
"https://www.example.com": "http://www.example.com",
"into your energy usage, costs, and carbon footprint.": "\u00fcber Ihren Energieverbrauch, Ihre Kosten und Ihre CO2-Bilanz.",
"kWh": "kWh",
"measuring the Carbon dioxide Consumption. potential difference across a surface area, we use the unit carbon dioxide per square meter (Co2/m2)": "um den Kohlendioxidverbrauch zu messen, verwenden wir die Einheit Kohlendioxid pro Quadratmeter (Co2/m2)",
"measuring the electrical potential difference across a surface area, we use the unit volts per square meter (V/m2)": "zur Messung der elektrischen Potentialdifferenz \u00fcber eine Fl\u00e4che wird die Einheit Volt pro Quadratmeter (V/m2) verwendet",
"or": "oder",
"page": "Seite",
"q": "q",
"real-time, accurate insights": "echtzeit, genaue Einblicke",
"ubscription Expire A": "Abonnement l\u00e4uft ab A",
"v": "vs"
},
"plural": "(n != 1)"
}